import { type ButtonHTMLAttributes } from "react";
import { cn } from "@/shared/utils/cn";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: "sm" | "md" | "lg";
  variant?: "ghost" | "glass";
};

export function IconButton({ className, size = "md", variant = "ghost", children, ...rest }: Props) {
  const sizeClass =
    size === "sm" ? "w-8 h-8" : size === "lg" ? "w-14 h-14" : "w-11 h-11";
  const variantClass =
    variant === "glass"
      ? "glass rounded-2xl"
      : "rounded-full hover:bg-white/5";
  return (
    <button
      {...rest}
      className={cn(
        "inline-flex items-center justify-center text-white/80 active:scale-95 transition-all",
        sizeClass,
        variantClass,
        className,
      )}
    >
      {children}
    </button>
  );
}
